import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';

export const BUTTON_GROUP_COMPONENT_TYPE = StreamComponentType.BUTTON_GROUP;

export const MAX_BUTTONS = 3;

export type ButtonStyle = 'primary' | 'secondary';

export interface DownloadButtonAction {
  type: 'download';
  chatId: string;
  hashedId: string;
  fileType: string;
  imageQuality: string;
}

export type ButtonAction = DownloadButtonAction;

export interface ButtonSpec {
  label: string;
  action: ButtonAction;
  icon?: string;
  style?: ButtonStyle;
}

export interface ButtonGroupProps {
  buttons: ButtonSpec[];
}

export type ButtonGroupComponentPart = BaseComponentPart<StreamComponentType.BUTTON_GROUP, ButtonGroupProps>;
